module.exports = __webpack_public_path__ + "NewCampus-b559459d.webp";